/**
 * Reusable currency selector with flag icons
 */

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CircleFlag } from 'react-circle-flags';
import { CURRENCIES } from '../config/currencies';

interface CurrencySelectProps {
  value: string;
  onValueChange: (value: string) => void;
  className?: string;
}

export const CurrencySelect: React.FC<CurrencySelectProps> = ({
  value,
  onValueChange,
  className
}) => {
  const selectedCurrency = CURRENCIES.find(c => c.code === value);

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={className}>
        <SelectValue>
          <div className="flex items-center gap-2">
            {selectedCurrency && (
              <CircleFlag
                countryCode={selectedCurrency.countryCode}
                height="20"
                width="20"
              />
            )}
            <span>{value}</span>
          </div>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {CURRENCIES.map((currency) => (
          <SelectItem key={currency.code} value={currency.code}>
            <div className="flex items-center gap-2">
              <CircleFlag
                countryCode={currency.countryCode}
                height="20"
                width="20"
              />
              <span className="font-medium">{currency.code}</span>
              <span className="text-muted-foreground text-xs">
                {currency.symbol} - {currency.name}
              </span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
